import i18n from "@microdoing/shared/i18n";
import theme from "app/Theme/Theme";
import normalize from "app/utils/normalize";
import React from "react";
import FastImage, { Source } from "react-native-fast-image";
import { Box } from "../Box";
import { MainText } from "../MainText";

const LongDarkLogo = require("./../../../../assets/images/long-dark-logo.png");

interface IProps {
  image: Source | number;
}

const OnboardingWebInfo = ({ image }: IProps) => {
  return (
    <Box
      flex={1}
      borderTopLeftRadius={theme.breakpoints.webMedium ? 20 : 0}
      borderBottomLeftRadius={theme.breakpoints.webMedium ? 20 : 0}
      backgroundColor="neutral.50"
      paddingRight="webXL"
      paddingTop={{ smallWeb: "webXM", web: "webL" }}
    >
      <Box alignItems="flex-end" height="100%">
        <Box width={normalize(344)} style={{ marginBottom: "130px" }}>
          <FastImage
            resizeMode="contain"
            source={LongDarkLogo}
            style={styles.webLongLogo}
          />
          <MainText variant="l2-medium" color="neutral.400" marginTop="sm">
            {i18n.t("web-intro-text-logo")}
          </MainText>
        </Box>
        <FastImage
          source={image}
          resizeMode="contain"
          style={styles.webImage}
        />
      </Box>
    </Box>
  );
};

const styles = {
  webLongLogo: {
    height: normalize(16),
    width: normalize(110),
  },
  webImage: {
    width: normalize(274),
    height: normalize(280),
  },
};

export default OnboardingWebInfo;
